import React, { VFC } from 'react';
import { Theme, useTheme } from '@material-ui/core/styles';
import mvPc from '../../../../images/features/ambassador/mv_pc.jpg';
import mvSp from '../../../../images/features/ambassador/mv_sp.jpg';
import styled from 'styled-components';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const H1 = styled.h1<{ theme: Theme }>`
  padding: ${({ theme }) => theme.spacing(2, 2, 4)};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: ${({ theme }) => theme.spacing(4)}px;
  }
`;
const Img = styled.img<{ theme: Theme }>`
  width: 100%;
  border-radius: 4px;
`;
const Description = styled.div<{ theme: Theme }>`
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  white-space: pre-wrap;
  margin: ${({ theme }) => theme.spacing(0, 2, 2)};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    margin: ${({ theme }) => theme.spacing(0, 4, 4)};
  }
`;

interface Props {}

const Top: VFC<Props> = () => {
  const theme = useTheme();
  const isPc = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  return (
    <div>
      <H1 theme={theme}>
        <Img
          src={isPc ? mvPc : mvSp}
          alt="地域の魅力を発信！おてつたびアンバサダー"
          theme={theme}
        />
      </H1>
      <Description theme={theme}>
        日本各地でおてつたびをしながら、地域の魅力を発信していただける「おてつたびアンバサダー」のプロフィールを紹介します。
        {'\n'}気になるアンバサダーを見つけたら、SNSをチェック！
      </Description>
    </div>
  );
};

export default Top;
